import * as actions from './actions'

const defaultFamilyState = {
  crudAction: 'LIST',
  childId: ''
}

const familyReducer = (state = defaultFamilyState, action) => {
  switch(action.type) {
    case actions.SET_PROFILE_ID:
      return Object.assign({}, state, { profileId: action.profileId })
    case actions.SET_FAMILY_CRUD_ACTION:
      return Object.assign({}, state, { crudAction: action.crudAction })
    default:
      return state
  }
}

export default familyReducer
